import type { Item } from '@easymoving/types';

/** Minimal i18n surface so the builder stays unit-testable in node. */
type Translate = (key: string, params?: Record<string, unknown>) => string;

/**
 * Compose a copy-paste-ready secondhand listing (Yad2 / Facebook) for an item
 * marked "sell": name, condition, dimensions, asking price — skipping whatever
 * is missing. Pure.
 */
export function buildListingText(
  item: Item,
  t: Translate,
  opts?: { conditionLabel?: string },
): string {
  const lines: string[] = [];
  lines.push(t('listing.heading', { name: item.nickname?.trim() || item.name }));
  if (opts?.conditionLabel) lines.push(t('listing.condition', { condition: opts.conditionLabel }));
  if (item.length && item.width && item.height) {
    const dims = `${item.length}×${item.width}×${item.height}${item.dimensionUnit ? ` ${item.dimensionUnit}` : ''}`;
    lines.push(t('listing.dims', { dims }));
  }
  if (item.estimatedValue != null) {
    lines.push(
      t('listing.price', { price: `${item.estimatedValue}${item.currency ? ` ${item.currency}` : ' ₪'}` }),
    );
  }
  if (item.notes?.trim()) lines.push(item.notes.trim());
  lines.push(t('listing.footer'));
  return lines.join('\n');
}
